var coachTip = {
    base: {
        display: "grid",
        alignItems: "stretch",
        boxSizing: "border-box",
        font: "body",
        padding: 5,
        borderRadius: 3,
        width: "100%",
        gridTemplateColumns: "min-content 1fr",
        gridGap: "3",
        ".icon": {
            width: "20px",
            height: "20px",
        },
    },
    variants: {
        look: {
            success: {
                backgroundColor: "success.10",
                ".icon": {
                    color: "success.60",
                },
            },
            critical: {
                backgroundColor: "critical.10",
                ".icon": {
                    color: "critical.60",
                },
            },
            warning: {
                backgroundColor: "warning.10",
                ".icon": {
                    color: "warning.60",
                },
            },
            information: {
                backgroundColor: "primary.10",
                ".icon": {
                    color: "primary.70",
                },
            },
        },
    },
};

export { coachTip };
//# sourceMappingURL=coach-tip.js.map
